import Box from "@mui/material/Box";
import React, { useState, useRef } from "react";
import AddIcon from '@mui/icons-material/Add';
import LoadingButton from "@mui/lab/LoadingButton";
import { Button, TextField, Grid, Tooltip, IconButton, MenuItem } from "@mui/material";
import PostDialog from "../components/PostDialog";
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import Divider from '@mui/material/Divider';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import axios from "axios";
import { errorNotify, successNotify } from "../../util/functions";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IEditionPayload } from "./interface";

interface IEddProps {
  edition: IEditionPayload;
  setEdition: (x: IEditionPayload) => void;
  setSelectedPhoto: (x: any) => void;
}


const Edit = (props: IEddProps) => {

  //props
  const {
    edition,
    setEdition,
    setSelectedPhoto
  } = props



  //hooks
  const selectPhoto: any = useRef(null);
  const [image, setImage] = useState<string>("");


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEdition({ ...edition, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={3} xs={12} sm={3}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              <div style={{ width: "15vw", height: "30vh", border: "1px solid gray" }}>
                <img
                  // src={image}
                  src={
                    Object.keys(image).length > 0
                      ? image
                      : `${SITEWEB_SERVER_BASE_URL}/etabLogoImage/${edition.libImageEtab}`
                  }
                  style={{ width: "15vw", height: "30vh" }}
                />
              </div>
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger l'image descriptive de l'actualité">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger la photo
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                size="small"
                name="libEtab"
                label="Libellé établissement"
                value={edition.libEtab}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Edit;





